<template>
    <div class="container">
        <b-table
            :data="categories"
            :loading="loading"
        >
            <template slot-scope="props">
                <b-table-column  width="40" numeric>
                    <a class="has-text-danger"
                    @click="deleteModal=true; idToDelete=props.row.id">
                        <b-icon 
                        icon="trash"
                        size="is-small">
                        </b-icon>
                    </a>
                </b-table-column>
                <b-table-column label="Titulo">
                    <b-input
                    v-model="props.row.title"
                    @input="updateCategory(props.row)">
                    </b-input>
                </b-table-column>
                <b-table-column label="Subcategorias">
                    {{props.row.subcategoriesCount}}
                </b-table-column>
            </template>
        </b-table>

        <b-modal :active.sync="deleteModal" scroll="keep">
            <div class="modal-card" style="width: auto">

                <div class="modal-card-body has-text-centered">
                    <p>
                        Eliminar esta categoria va a eliminar tambien a todas las subcategorias dentro de ella. 
                        Esto va a dejar a un monton de productos sin seccion, por lo que no apareceran en el sitio correctamente.
                    </p>
                    <p> <b>Seguro que quieres continuar?</b> </p>
                    <div class="columns m-t-20">
                        <div class="column has-text-centered is-full">
                            <b-button
                                type="is-grey"
                                rounded
                                @click="deleteModal=false">
                                    Cancelar
                            </b-button>
                            <b-button
                                type="is-danger"
                                rounded
                                @click="deleteCat">
                                    Eliminar
                            </b-button>
                        </div>
                    </div>
                    
                </div>
                
            </div>
        </b-modal>

    </div>
</template>

<script>
import { getHandler, debounce, patchHandler, deleteHandler } from '../../../../services/http'
export default {
    props:{

        categoryDetailUrl:{
            type:String,
            default:""
        },
        categories:{
            type:Array,
            default:new Array([])
        },
        loading:{
            type:Boolean,
            default:false
        }
    },
    data(){
        return{
            idToDelete:'',
            deleteModal:false
        }
    },
    methods:{
        fetchCategories(){
            this.$emit("loadCategories")
        },
        fetchSubCategories(){
            this.$emit("loadSubs")
        },
        updateCategory: debounce(async function(category){
            let msgS={
                resource:"toast",
                text:"Categoria editada con exito"
            }
            let msgE={
                resource:"toast",
                text:"Algo salio mal, intenta otra vez"
            }
            let url = this.categoryDetailUrl.replace("0000", category.id)
            let resp = await patchHandler(url, category, {error:msgE, success:msgS})
            this.fetchCategories()
            this.fetchSubCategories()
        }, 500),
        async deleteCat(){
            let msgS={
                resource:"toast",
                text:"Categoria eliminada con exito"
            }
            let msgE={
                resource:"toast",
                text:"Algo salio mal, intenta otra vez"
            }
            let url = this.categoryDetailUrl.replace("0000", this.idToDelete)
            let resp = await deleteHandler(url, {error:msgE, success:msgS})
            this.deleteModal = false
            this.fetchCategories()
            this.fetchSubCategories()
        }
    },

}
</script>